import React, {
  FC, useCallback, useEffect, useMemo, useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { AcceptRequestModal } from '../acceptRequestModal';
import Button from 'components/base/Button';
import { useArticles } from 'hooks/useArticles';
import { useFeatures } from 'hooks/useFeatures/useFeatures';
import { OrderDraft } from 'models/OrderDraft';

interface IAcceptFlowersButton {
  id: number | undefined;
}
export const AcceptFlowersButton: FC<IAcceptFlowersButton> = ({ id }) => {
  const { t } = useTranslation();
  const {
    getArticleDraft,
  } = useArticles();
  const {
    canAcceptFlowersRequest,
  } = useFeatures();

  const [acceptModalShow, setAcceptModalShow] = useState<boolean>(false);
  const [articleDraft, setArticleDraft] = useState<OrderDraft>();

  const isAcceptEnabled = useMemo(
    () => {
      if (articleDraft) {
        return canAcceptFlowersRequest({
          status: articleDraft.status,
        });
      }
      return false;
    },
    [articleDraft, canAcceptFlowersRequest],
  );

  const fetchArticle = useCallback(
    (articleId) => {
      getArticleDraft(articleId)
        .then((response) => {
          setArticleDraft(response);
          return response;
        }).catch(() => {
          setArticleDraft(undefined);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(
    () => {
      if (id) {
        fetchArticle(id);
      } else {
        setArticleDraft(undefined);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id],
  );

  return (
    <React.Fragment>
      <Button
        color="secondary"
        disabled={!isAcceptEnabled}
        text={t('article.flowers.acceptOrder')}
        onClick={() => {
          setAcceptModalShow(true);
        }}
      />
      <AcceptRequestModal
        id={id}
        show={acceptModalShow}
        onHide={() => {
          setAcceptModalShow(false);
        }}
        onSuccess={() => {
          fetchArticle(id);
        }}
      />
    </React.Fragment>
  );
};
